import React from "preact/compat";
import {h} from 'preact';
import { CheckOutlined } from "@ant-design/icons";

export default function DataLibraryMenuSection(props) {
  const sectionNote = (section) => {
    const itemCount = section.items.length;
    if (itemCount > 0) {
      return <span className="item-count">({itemCount} item{itemCount > 1 ? 's' : ''})</span>;
    }
    return null;
  }

  function highlightText(text, search) {
    if (!search || !text) return text;

    const getParts = (search, text) => {
      const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escapedSearch})`, 'gi');
      return text.split(regex);
    }

    return getParts(search, text).map((part, index) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span key={index} className={'highlighted-part'}>{part}</span>
      ) : (
        part
      )
    );
  }

  return <ul className={"ssc"}>
    {props
      .sections
      .sort((a, b) => (a.sequence || 0) - (b.sequence || 0))
      .map(section =>
        <li onClick={(e) => {e.stopPropagation(); props.selectSection(section)} }>
          {!!section.sections?.length && <div 
            className={`check-all ${props.isAllSubsectionsChecked(section) ? 'checked' : 'unchecked'}`} 
            onClick={() => props.selectAllSections(section)}>
              <CheckOutlined/>
          </div>}
          <div className={`item ${section.checked ? 'sel' : ''} ${!section.items.length ? 'no-items' : ''} ${section.sections?.length ? 'has-children' : ''}`}>
            <span className="name">{highlightText(section.name || 'Group Name', props.searchBy)} {sectionNote(section)}</span>
          </div>
          {!!section.sections?.length && <DataLibraryMenuSection
            searchKey={props.searchKey}
            sections={section.sections}
            selectSection={props.selectSection}
            selectAllSections={props.selectAllSections}
            isAllSubsectionsChecked={props.isAllSubsectionsChecked}
          />}
        </li>
      )}
  </ul>
}
